module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-tag"
  }, [_c('div', {
    staticClass: "d-tag__text"
  }, [_vm._v(_vm._s(_vm.tag))]), _vm._v(" "), _c('div', {
    staticClass: "icon-cross2 d-tag__icon",
    on: {
      "click": function($event) {
        return _vm.remove(_vm.tag)
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6bfee519!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tagging/Tag.vue
// module id = 1989
// module chunks = 1